import Swal from "sweetalert2";

// Base config shared by every popup
const CustomSwal = Swal.mixin({
  buttonsStyling: false,           // turn off default button styles
  showClass: {
    popup: "animate__animated animate__fadeInDown", // optional (needs animate.css)
  },
  customClass: {
    popup: "my-swal-popup",
    title: "my-swal-title",
    htmlContainer: "my-swal-text",
    confirmButton: "my-swal-confirm",
    cancelButton: "my-swal-cancel",
    icon: "my-swal-icon",
  },
});

export const showSuccess = (title: string, text?: string) =>
  CustomSwal.fire({ icon: "success", title, text, confirmButtonText: "OK" });

export const showError = (title: string, text?: string) =>
  CustomSwal.fire({ icon: "error", title, text, confirmButtonText: "Close" });

export const showConfirm = async (title: string, text?: string) => {
  const result = await CustomSwal.fire({
    icon: "warning",
    title,
    text,
    showCancelButton: true,
    confirmButtonText: "Yes, do it",
    cancelButtonText: "Cancel",
    reverseButtons: true,
  });
  return result.isConfirmed;
};

export default CustomSwal;